(function($) {
    $.fn.locationSelect = function(options) {
        var settings = {
            details_el: ".details",
            clear_btn_el: ".clear-btn"
        };

        settings = $.extend(settings, options);

        var params = new URLSearchParams(location.search),
            $autocomplete = $(this),
            $clear_btn = $(settings.clear_btn_el),
            $location_details = $(settings.details_el);

        // Load city to input after page loaded
        $(document).ready(function() {
            if (!settings.skipLoading) {
                $clear_btn.css("visibility", "hidden");
            }

            if (params.get("lat") && params.get("lng")) {
                $autocomplete.attr("data-lat", params.get("lat"));
                $autocomplete.attr("data-lng", params.get("lng"));

                if (params.get("distance")) {
                    $location_details.addClass("active");

                    var $distance = $('[data-value="' + params.get("distance") + '"]'),
                        $active = $("[data-value].active");

                    if (params.get("distance") != $active.attr("data-value")) {
                        if ($distance.length) {
                            $active.removeClass("active");
                            $distance.addClass("active");
                        }
                    }
                }

                if (!settings.skipLoading) {
                    $.getJSON(
                        "https://maps.googleapis.com/maps/api/geocode/json?key=" +
                            settings.google_key +
                            "&latlng=" +
                            params.get("lat") +
                            "," +
                            params.get("lng"),
                        function(data) {
                            if (data.results && data.results.length && data.results[0].address_components && data.results[0].address_components.length) {
                                var addresses = data.results[0].address_components;

                                for (var i = 0; i < addresses.length; i++) {
                                    if (addresses[i].types.indexOf("locality") >= 0) {
                                        $autocomplete.val(addresses[i].long_name);
                                        $clear_btn.css("visibility", "visible");
                                        break;
                                    }
                                }
                            }
                        }
                    );
                }
            }
        });

        var redirectWithParams =
            settings.redirect ||
            function() {
                var params = new URLSearchParams(location.search);
                params.set("lat", $autocomplete.attr("data-lat"));
                params.set("lng", $autocomplete.attr("data-lng"));
                params.set("distance", $("[data-value].active").attr("data-value"));
                params.delete("page");

                location.replace(location.pathname + "?" + params);
            };

        var countryRestrict = { country: "pl" },
            autocompletes = [],
            place,
            lat,
            lng;

        // Load google maps autocomplete
        $autocomplete.each(function(index) {
            autocompletes[index] = new google.maps.places.Autocomplete(document.getElementsByClassName("autocomplete")[index], {
                types: ["geocode"],
                componentRestrictions: countryRestrict
            });

            autocompletes[index].addListener("place_changed", function() {
                place = autocompletes[index].getPlace();

                if (place.geometry) {
                    lat = place.geometry.location.lat();
                    lng = place.geometry.location.lng();

                    $autocomplete.attr("data-lat", lat).attr("data-lng", lng);

                    redirectWithParams();
                }
            });
        });

        // Hide/show clear_btn when typing in autocomplete input
        $autocomplete.on("input", function() {
            var $this = $(this),
                $btn = $this.parent(".flex").find(settings.clear_btn_el),
                hidden = $btn.css("visibility") == "hidden";

            if ($this.val() && hidden) {
                $btn.css("visibility", "visible");
            } else if (!$this.val() && !hidden) {
                $btn.css("visibility", "hidden");
            }
        });

        // Clear input and hide details element
        var clearFunction =
            settings.clear ||
            function() {
                var $this = $(this),
                    $input = $this.parent(".flex").find("input"),
                    $location_details = $this.parents(".flex").find(settings.details_el);

                $this.css("visibility", "hidden");
                $input.val("");

                if ($location_details.hasClass("active")) {
                    $location_details.removeClass("active");
                }

                if (location.search.indexOf("lat=") >= 0) {
                    const params = new URLSearchParams(location.search);

                    params.delete("lat");
                    params.delete("lng");
                    params.delete("distance");
                    params.delete("page");

                    location.replace(location.origin + location.pathname + (params.toString() ? "?" + params.toString() : ""));
                }
            };
        $clear_btn.click(clearFunction);

        // Change distance buttons
        $(".location-details.active [data-value]").click(function() {
            $("[data-value].active").removeClass("active");
            $(this).addClass("active");

            redirectWithParams();
        });
    };
})(jQuery);
